/**
 * Página de Solicitação de Acesso ao Sistema (RQ35)
 * 
 * Formulário isolado para solicitação rápida de acesso aos sistemas internos
 */

import React, { useState, useEffect } from 'react'
import { TemplateQuickForm } from './TemplateQuickForm'
import { getSolicitacaoAcessoSistemaSchema } from '../schemas/RQ35-solicitacaoAcessoSistema'
import type { TemplateSchema } from '../types'
import { Loader2 } from 'lucide-react'

const PROCESSO_VINCULADO_ID = 108 // Processo: "Solicitação de Acesso ao Sistema"

export const SolicitacaoAcessoSistemaPage: React.FC = () => {
  const [schema, setSchema] = useState<TemplateSchema | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function loadSchema() {
      try {
        setIsLoading(true)
        const loadedSchema = await getSolicitacaoAcessoSistemaSchema()
        setSchema(loadedSchema)
      } catch (err) {
        console.error('Erro ao carregar schema:', err)
        setError('Erro ao carregar o formulário. Tente novamente.')
      } finally {
        setIsLoading(false)
      }
    }

    loadSchema()
  }, [])

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="flex flex-col items-center gap-3">
          <Loader2 className="w-8 h-8 text-blue-500 animate-spin" />
          <p className="text-sm text-gray-600 dark:text-gray-400">
            Carregando formulário...
          </p>
        </div>
      </div>
    )
  }

  if (error || !schema) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <p className="text-red-500 dark:text-red-400">{error || 'Erro ao carregar o formulário'}</p>
        </div>
      </div>
    )
  }

  return (
    <TemplateQuickForm
      templateId="solicitacao_acesso_sistema"
      templateSchema={schema}
      processoVinculado={PROCESSO_VINCULADO_ID}
    />
  )
}
